import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '@/core/permissions/permission.service';
import { PERMISSOES } from '@/core/permissions/permissoes.catalog';

export const servicosVisualizarGuard: CanActivateFn = (route) => {
    const perm = inject(PermissionService);
    const router = inject(Router);
    const tipo = route.paramMap.get('tipo');
    const role = tipo === 'pessoa-juridica' ? PERMISSOES.pessoaJuridica.servicos.visualizar : PERMISSOES.pessoaFisica.servicos.visualizar;
    return perm.can(role) ? true : router.createUrlTree(['/sem-acesso']);
};
